import React from "react";
import { Switch, HashRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@material-ui/styles";
import { SessionProvider } from "context/SessionContext";
import Routes from "routes/index";
import { theme } from "assets/styles/theme";
import { ToastContainer } from "components/shared";

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Router>
          <SessionProvider>
            <Switch>
              <Routes />
            </Switch>
          </SessionProvider>
        </Router>
      </ThemeProvider>
      <ToastContainer />
    </>
  );
}

export default App;
